import React from 'react';
import Footer from '../../components/footer';
import Navbar from '../../components/navbar';
import Text from '../../components/text/Text';
import { ProjectSection } from '../../components/NewProjectsSection';
import { projectsData } from '../../data/projects';

function Projects() {
    return (
        <body>
            <Navbar />
            <hr className='hr-min' />
            <div className='container'>
                <Text as='h1' fontSize={56} variant='yellow-green'>Projetos</Text>
            </div>

            {projectsData.map((project, index) => (
                <React.Fragment key={project.id}>
                    <ProjectSection
                        project={project}
                        // Se o índice for ímpar o isReversed será true
                        isReversed={index % 2 !== 0}
                    />
                    {index < projectsData.length - 1 && <hr className='hr-min' />}
                </React.Fragment>
            ))}

            <Footer />
        </body>
    );
}

export default Projects;